var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCoeur(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 331,
    height: 329,
    viewBox: "0 0 331 329",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M255.297 8.96556C219.293 -5.09173 184.518 -0.778658 152.766 21.983C131.886 36.9498 118.134 57.08 112.146 82.0775C110.05 90.8411 109.231 99.9097 107.764 109.262C107.934 109.205 107.833 109.268 107.72 109.268C105.431 109.411 103.122 109.522 100.833 109.689C70.0577 111.924 44.4396 124.722 25.0164 148.528C4.78857 173.313 -3.23483 202.029 2.18472 233.676C8.18471 268.709 27.1686 294.94 58.897 311.277C84.0757 324.231 111.42 328.466 139.467 328.809C166.564 329.147 193.502 326.355 220.421 323.681C244.944 321.245 269.517 318.645 293.15 311.309C309.105 306.354 306.006 309.491 311.262 293.888C320.996 264.993 326.346 235.159 328.638 204.828C331.824 162.919 330.784 121.319 319.157 80.4983C309.409 46.2748 288.199 21.8176 255.297 8.96556",
    fill: "#6B0F14"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoeur);
export default __webpack_public_path__ + "static/media/Coeur.244ec32f76a6df34addea2152e20ba34.svg";
export { ForwardRef as ReactComponent };